import { useCallback } from 'react';

import { mapLocalStorage } from 'entities/map';

import { MapName } from 'entities/map';

export const useHandleClickMapType = () => {
  const handleClickMapType = useCallback((mapName: MapName) => {
    mapLocalStorage.updateName(mapName);
    window.location.reload();
  }, []);

  return handleClickMapType;
};
